import React from 'react'
import { Box, Text, FlexProps, Flex } from '@chakra-ui/react'

export interface SectionHeaderProps extends FlexProps {
  tools?: React.ReactNode
}

const SectionHeader = ({
  children,
  tools,
  ...restProps
}: SectionHeaderProps) => {
  return (
    <Flex bg="blue.900" p={3} justifyContent="space-between" {...restProps}>
      <Text fontWeight="bold" color="white">
        {children}
      </Text>
      {tools && <Box>{tools}</Box>}
    </Flex>
  )
}

export default SectionHeader
